import createPopper from './createPopper.js';
import getPopperMaxHeight from './getPopperMaxHeight.js';
import getClassName from './getClassName.js';
import Popper from './popper.js';
var clk = function clk(e) {
  e.nativeEvent.stopImmediatePropagation();
};
var getDeps = function getDeps() {
  return {
    createPopper: createPopper,
    getPopperMaxHeight: getPopperMaxHeight,
    getClassName: getClassName,
    clk: clk
  };
};
export default Popper.bind(null, getDeps);